"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@comunica/core");
/**
 * A comunica actor for rdf-resolve-quad-pattern events.
 *
 * Actor types:
 * * Input:  IActionRdfResolveQuadPattern:      A quad pattern and an optional context.
 * * Test:   <none>
 * * Output: IActorRdfResolveQuadPatternOutput: The resulting quad stream and optional metadata.
 *
 * @see IActionRdfResolveQuadPattern
 * @see IActorRdfResolveQuadPatternOutput
 */


var ActorRdfResolveQuadPattern =
/*#__PURE__*/
function (_core_1$Actor) {
  _inherits(ActorRdfResolveQuadPattern, _core_1$Actor);

  function ActorRdfResolveQuadPattern(args) {
    _classCallCheck(this, ActorRdfResolveQuadPattern);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorRdfResolveQuadPattern).call(this, args));
  }
  /**
   * Get the sources from the given context.
   * @param {ActionContext} context An optional context.
   * @return {IDataSource[]} The array of sources or null.
   */


  _createClass(ActorRdfResolveQuadPattern, [{
    key: "getContextSources",
    value: function getContextSources(context) {
      return context ? context.get(exports.KEY_CONTEXT_SOURCES) : null;
    }
    /**
     * Get the source from the given context.
     * @param {ActionContext} context An optional context.
     * @return {IDataSource} The source or null.
     */

  }, {
    key: "getContextSource",
    value: function getContextSource(context) {
      return context ? context.get(exports.KEY_CONTEXT_SOURCE) : null;
    }
    /**
     * Get the source's raw URL value from the given context.
     * @param {IDataSource} source A source.
     * @return {string} The URL or null.
     */

  }, {
    key: "getContextSourceUrl",
    value: function getContextSourceUrl(source) {
      if (source) {
        var fileUrl = getDataSourceValue(source); // Remove hashes from source

        var hashPosition = fileUrl.indexOf('#');

        if (hashPosition >= 0) {
          fileUrl = fileUrl.substr(0, hashPosition);
        }

        return fileUrl;
      }

      return null;
    }
    /**
     * Check if the given context has a single source.
     * @param {ActionContext} context An optional context.
     * @return {boolean} If the given context has a single source of the given type.
     */

  }, {
    key: "hasContextSingleSource",
    value: function hasContextSingleSource(context) {
      var source = this.getContextSource(context);
      return !!(source && (typeof source === 'string' || source.value));
    }
    /**
     * Check if the given context has a single source of the given type.
     * @param {string} requiredType The required source type name.
     * @param {ActionContext} context An optional context.
     * @return {boolean} If the given context has a single source of the given type.
     */

  }, {
    key: "hasContextSingleSourceOfType",
    value: function hasContextSingleSourceOfType(requiredType, context) {
      var source = this.getContextSource(context);
      return !!(source && getDataSourceType(source) === requiredType && getDataSourceValue(source));
    }
  }]);

  return ActorRdfResolveQuadPattern;
}(core_1.Actor);

exports.ActorRdfResolveQuadPattern = ActorRdfResolveQuadPattern;

function getDataSourceType(dataSource) {
  return typeof dataSource === 'string' ? '' : dataSource.type;
}

exports.getDataSourceType = getDataSourceType;

function getDataSourceValue(dataSource) {
  return typeof dataSource === 'string' ? dataSource : dataSource.value;
}

exports.getDataSourceValue = getDataSourceValue;
/**
 * @type {string} Context entry for data sources.
 * @value {DataSources} An array or stream of sources.
 */

exports.KEY_CONTEXT_SOURCES = '@comunica/bus-rdf-resolve-quad-pattern:sources';
/**
 * @type {string} Context entry for a data source.
 * @value {IDataSource} A source.
 */

exports.KEY_CONTEXT_SOURCE = '@comunica/bus-rdf-resolve-quad-pattern:source';